import React from 'react';
import { CardContent, Stack } from '@mui/material';
import { useAppSelector } from '../../../../app/hooks';
import TemplateInformationSection from './sections/TemplateInformationSection';
import ScheduleConfigurationSection from './sections/ScheduleConfigurationSection';
import AssignmentSection from './sections/AssignmentSection';
import LifecycleSection from './sections/LifecycleSection';
import { HstAccessSection } from '../../../tickets/components/TicketForm/sections/HstAccessSection';
import { CpsiAccessSection } from '../../../tickets/components/TicketForm/sections/CpsiAccessSection';
import { FacilityMaintenanceSection } from '../../../tickets/components/TicketForm/sections/FacilityMaintenanceSection';
import { PMDetailsSection } from '../../../tickets/components/TicketForm/sections/PMDetailsSection';
import { RecurringTaskGeneralTicketTemplateSection } from './sections/RecurringTaskGeneralTicketTemplateSection';

/**
 * RecurringTaskEditForm - Main form container for recurring task editing
 * Shows conditional template sections based on category selection
 */
export const RecurringTaskEditForm: React.FC = () => {
  const currentRecurringTask = useAppSelector(state => state.recurringTask.currentRecurringTask);
  
  // Determine which template section to show based on category
  const showGeneralTicketTemplateSection = currentRecurringTask?.category === 'GEN';
  const showHstAccessSection = currentRecurringTask?.category === 'HST';
  const showCpsiAccessSection = currentRecurringTask?.category === 'CPSI';
  const showFacilityMaintenanceSection = currentRecurringTask?.category === 'FAC';
  const showPMSection = currentRecurringTask?.category === 'PM';
  
  return (
    <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
      <form autoComplete="off">
        <Stack spacing={2.5}>
          <TemplateInformationSection isEditMode />
          
          {/* Conditional Template/Access Request Sections based on category */}
          {showGeneralTicketTemplateSection && <RecurringTaskGeneralTicketTemplateSection />}
          {showHstAccessSection && <HstAccessSection mode="recurringTask" />}
          {showCpsiAccessSection && <CpsiAccessSection mode="recurringTask" />}
          {showFacilityMaintenanceSection && <FacilityMaintenanceSection mode="recurringTask" />}
          {showPMSection && <PMDetailsSection mode="recurringTask" showFindings={false} showPartsUsed={false} />}
          
          <ScheduleConfigurationSection />
          <AssignmentSection />
          <LifecycleSection />
        </Stack>
      </form>
    </CardContent>
  );
};

export default RecurringTaskEditForm;
